import { useEffect } from 'react';

// Utils
import { useNavigate } from 'react-router-dom';
import { useAppContext } from '../store/AppContext';
import { isGranted } from '../utils/gate/permissionsGate';
import withAuth from '../utils/hocs/withAuth';
import sidebarMenuEntries from '../constants/sidebarMenuEntries';

function Index() {
  const navigate = useNavigate();
  const [{ user }] = useAppContext();

  useEffect(() => {
    if (user) {
      const entries = sidebarMenuEntries.filter((entry) => (entry.permScope ? isGranted(user, entry.permScope) : true));

      if (entries?.length) {
        if (entries[0]?.path) {
          navigate(entries[0].path);
        }

        if (entries[0]?.subLevels?.[0]?.path) {
          navigate(entries[0].subLevels[0].path);
        }
      }
    }
  }, [user]);

  return null;
}

export default withAuth(Index);
